import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.DISPATCH_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.local.setItem(types.DISPATCH_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.DISPATCH_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.DISPATCH_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.DISPATCH_FILTER_BY, filterBy)
  },
  [types.SET_CENTER](state, center) {
    state.center = center
  },
  [types.SET_TECH](state, id) {
    state.currentTech = null
    if (id) {
      if (state.techs) {
        let found = state.techs.find(x => parseInt(x.contact) === parseInt(id))
        if (found) {
          state.currentTech = JSON.parse(JSON.stringify(found))
          state.currentTech.notes = ''
          state.currentTech.isSettingLocation = false
          state.currentTech.selectedDate = null
          state.currentTech.selectedTime = null
        }
      }
    }
    console.log('Set Tech', state.currentTech)
  },
  [types.SET_TECHS](state, data) {
    state.currentTechs = []
    if (data) {
      state.currentTechs = JSON.parse(JSON.stringify(data))
    }
  },
  [types.SET_TECH_LOCATION](state, data) {
    state.currentTech.latitude = data.latitude
    state.currentTech.longitude = data.longitude
    let found = state.techs.find(x => parseInt(x.contact) === parseInt(data.contact))
    if (found) {
      found.latitude = data.latitude
      found.longitude = data.longitude
    }
    console.log('Saved Tech Address', {
      address: data,
      currentTech: state.currentTech,
      techs: state.techs
    })
  },
  [types.SET_ADDRESS](state, data) {
    if (data) {
      switch (data.name) {
        case 'reset':
          state.address = JSON.parse(JSON.stringify(state.defaultAddress))
          break
        case 'contact':
          state.address.contact = data.value
          break
        case 'addressLines':
          state.address.addressLines = data.value
          break
        case 'city':
          state.address.city = data.value
          break
        case 'stateProvince':
          state.address.stateProvince = data.value
          break
        case 'stateProvinceAbbr':
          state.address.stateProvinceAbbr = data.value
          break
        case 'postalCode':
          state.address.postalCode = data.value
          break
        case 'latitude':
          state.address.latitude = data.value
          break
        case 'longitude':
          state.address.longitude = data.value
          break
      }
    }
  },
  [types.SET_TECH_STATUS](state, data) {
    let found = state.techs.find(x => parseInt(x.contact) === parseInt(data.contact))
    if (found) {
      found.technicianStatus = parseInt(data.technicianStatus)
    }
    state.currentTech.technicianStatus = parseInt(data.technicianStatus)
    console.log('Status Updated', {
      techs: state.techs,
      found: found,
      data: data
    })
  },
  [types.SET_TECHDATA](state, data) {
    // console.log('Set Tech Data', data)
    if (state.currentTech !== null && data !== null) {
      switch (data.name) {
        case 'Notes':
          state.currentTech.notes = data.value
          break
        case 'Status':
          state.currentTech.technicianStatus = parseInt(data.value)
          break
        case 'SettingLocation':
          state.currentTech.isSettingLocation = data.value
          break
        case 'SelectedDate':
          state.currentTech.selectedDate = data.value
          break
        case 'SelectedTime':
          state.currentTech.selectedTime = data.value
          break
      }
    }
    // console.log('Tech Data Set', state.currentTech)
  },
  [types.SET_TECH_ASSIGNMENTS](state, data) {
    state.techs = []
    if (data !== undefined && data !== null) {
      state.techs = data
    }
    console.log('Set Tech Assignments', state.techs)
  },
  [types.SET_TECH_MARKERS](state, data) {
    state.techMarkers = []
    if (data !== undefined && data !== null) {
      state.techMarkers = data
    }
    console.log('Set Tech Markers', state.techMarkers)
  },
  [types.SET_TECH_SCHEDULE](state, data) {
    state.techs = []
    state.schedule = []
    if (data !== undefined && data !== null) {
      state.techs = data.assignments
      state.schedule = data.schedule
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/mutations.js